import jsPDF from "jspdf";
import html2canvas from "html2canvas";

export async function fetchFileFromUrl(url: string): Promise<File> {
  const response = await fetch(url);
  const data = await response.blob();
  const parts = url.split("/");
  const last = parts[parts.length - 1];
  return new File([data], last);
}

export interface ResponseHeaders {
  "content-disposition"?: string;
  "content-length"?: string;
  "content-type"?: string;
}

export function downloadFileData(data: any, headers: ResponseHeaders): void {
  const contentDisposition =
    headers?.["content-disposition"]?.split("fileName=");
  const fileName =
    (contentDisposition?.length || 0) > 1 && contentDisposition?.[1];
  const url = window.URL.createObjectURL(data);
  const a = document.createElement("a");
  a.href = url;
  if (fileName) {
    a.download = fileName;
    a.click();
  }
}

export function downloadFile(url: string): void {
  const a = document.createElement("a");
  a.href = url;
  a.click();
}

const PAGE_LETTER_WIDTH = 215.9;
const PAGE_LETTER_HEIGHT = 279.4;
const margin = {
  top: 10,
  right: 10,
  bottom: 10,
  left: 10,
};

export async function savePdf(
  element: HTMLElement,
  fileName: string,
  bgColor = "#fff"
) {
  const canvas = await html2canvas(element, { scale: 1 });
  const canvasWidth = canvas.width;
  const canvasHeight = canvas.height;
  const innerPageWidth = PAGE_LETTER_WIDTH - margin.left - margin.right;
  const innerPageHeight = PAGE_LETTER_HEIGHT - margin.top - margin.bottom;
  const canvasHeightRel = (canvasWidth * innerPageHeight) / innerPageWidth;
  const pdfHeight = (canvasHeight * innerPageWidth) / canvasWidth;
  const imageHeight = (canvasWidth * pdfHeight) / innerPageWidth;
  const pageHeight = (canvasWidth * innerPageHeight) / innerPageWidth;
  const nuPages = Math.ceil(pdfHeight / innerPageHeight);
  const pdf = new jsPDF("portrait", "mm", [
    PAGE_LETTER_WIDTH,
    PAGE_LETTER_HEIGHT,
  ]);

  let curY = 0;
  for (let pageIndex = 0; pageIndex < nuPages; pageIndex++) {
    const pageCanvas = document.createElement("canvas");
    pageCanvas.setAttribute("width", `${canvasWidth}px`);
    pageCanvas.setAttribute("height", `${canvasHeightRel}px`);
    const ctx = pageCanvas.getContext("2d")!;
    ctx.drawImage(canvas, 0, curY, canvasWidth, imageHeight);
    const canvasDataURL = pageCanvas.toDataURL("image/png", 1.0);
    if (pageIndex > 0) {
      pdf.addPage();
    }
    pdf.setPage(pageIndex + 1);
    pdf.setFillColor(bgColor);
    pdf.rect(0, 0, PAGE_LETTER_WIDTH, PAGE_LETTER_HEIGHT, "F");
    pdf.addImage(
      canvasDataURL,
      "PNG",
      margin.left,
      margin.top,
      innerPageWidth,
      innerPageHeight
    );
    curY -= pageHeight;
  }
  pdf.save(fileName);
}
